import { DataTypeEnum } from "../../enums/DataTypeEnum";
import { DRCXAvailableObjectBase } from "./DRCXAvailableObjectBase";

export class DRCXAvailableTatTypeColumn extends DRCXAvailableObjectBase<number> {
    public constructor(displayText: string, id: number, public dataType: DataTypeEnum) {
        super(displayText, id);
    }
}
